module.exports = __webpack_public_path__ + "static/img/01.dbe0086.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/companies/loacker/01.jpg
// module id = 416
// module chunks = 1